module.exports = __webpack_public_path__ + "img/BYOCS_StressManagement.46f8b3cd.jpg";